import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { Student } from '../../models/student.model';
import { StudentService } from '../../services/student.service';

@Component({
  selector: 'app-student-info',
  templateUrl: './student-info.component.html',
  styleUrls: ['./student-info.component.scss']
})
export class StudentInfoComponent implements OnInit {

    public headerTitle     : string = 'Participantes';
    public headerButtonText: string = 'Volver';
    public headerButtonIcon: string = 'arrow-left';
    public headerButtonUrl : string = '/participantes';

    public studentId: number;
    public student  : Student;

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';

    constructor(private activatedRoute: ActivatedRoute, private studentService: StudentService) { }

    ngOnInit(): void {

        this.studentId = this.activatedRoute.snapshot.params["id"];
        this.initData();

    }

    private initData() {

        this.studentService.getById(this.studentId).subscribe({

            next: (data: Student) => {
                this.student = data;
            },

            error: (error: any) => {
                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);
            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

}
